<template>
  <div class="additional-features round-card-corners mt-4 ">
    <b-row class="justify-content-md-center">
      <b-col>
        <h4 class="text-white text-center p-3">
          Additional banking features on a {{cardPass}} {{accountType}}
        </h4>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center p-4 h-100">
      <b-col v-for="(card, index) in additionalFeatures" :key="index + health"
             cols="12"
             sm="6"
             md="6"
             lg="3"
             class="p-3 col-xxl-3 custom-col-additional-features"
      >
        <b-overlay
            :show="card.show"
            variant="secondary"
            :opacity="0.9"
        >
          <b-card class=" p-0 text-center round-card-corners card-item-a-b">
            <b-row class="h-100">
              <b-col my-auto class="my-auto">
                <img
                    :src="
                    require('@/assets/images/additional-features/' + card.img)
                  "
                    alt=""
                    srcset=""
                    :class="['img-icon', card.class]"
                />
                <p class="smallest-text mb-0 pt-2">{{ card.text }}</p>
              </b-col>
            </b-row>
          </b-card>
          <template #overlay>
            <div class="text-center">
              <img
                  :src="require('@/assets/images/icons/lock_white@2x.png')"
                  alt=""
                  srcset=""
                  class="img-icon"
              />
              <p class="text-white smallest-text mb-0" style="margin-top: 5px">{{ card.text }}</p>
              <p class="text-white subtext mt-1">{{ card.subText }}</p>
            </div>
          </template>
        </b-overlay>
      </b-col>
    </b-row
    >
  </div>
</template>


<script>
export default {
  props: ["benefits",'cardPass','accountType','health','apple_benefit_locked'],
  methods : {
    methodThatForcesUpdate() {
      // ...
      let displayList = []
      this.additionalFeatures.forEach((feature) => {

        if (feature.key === 'apple_benefits'){

          feature.show = this.apple_benefit_locked
        }
        if (feature.key === 'relationship'){

          feature.show = this.benefits.relationship === 'Locked'
        }
        displayList.push(feature)
      })

      this.additionalFeatures = displayList
    }
  },
  watch : {
    health(newValue, oldValue){
      if(newValue !== oldValue){
        this.methodThatForcesUpdate()
      }
    },
    cardPass(newValue, oldValue){
      if(newValue !== oldValue){
        this.methodThatForcesUpdate()
      }
    },
    accountType(newValue, oldValue){
      if(newValue !== oldValue){
        this.methodThatForcesUpdate()
      }
    }
  },
  data() {
    return {
      additionalFeatures: [
        {
          key: "apple_pay",
          img: "apple_pay.svg",
          text: "Apple Pay",
          subText: "",
          show: this.benefits.apple_pay !== 'Yes',
          class: "",
        },
        {
          key: "relationship",
          img: "handshake@2x.png",
          text: "Relationship banker",
          subText: "",
          show: this.benefits.relationship === 'Locked',
          class: "",
        },
        {
          key: "apple_benefits",
          img: "istore_icon_V1.svg",
          text: "Fully funded Apple Watch",
          subText: "",
          show: ((this.health !== 'yes') && (this.benefits.apple_benefits !== 'Yes')),
          class: "",
        },
        {
          key: "instant_credit",
          img: "bank_card_approved@2x.png",
          text: "Instant credit approval",
          subText: "",
          show: this.benefits.instant_credit !== 'Yes',
          class: "",
        },
        {
          key: "smart_search",
          img: "magnifying_glass@2x.png",
          text: "Smart Search",
          subText: "",
          show: this.benefits.smart_search !== 'Yes',
          class: "",
        },
        {
          key: "discovery_pay",
          img: "star@2x.png",
          text: "Discovery Pay",
          subText: "",
          show: this.benefits.discovery_pay !== 'Yes',
          class: "",
        },
        {
          key: "health_pay",
          img: "heart@2x.png",
          text: "Health Pay",
          subText: "",
          show: this.benefits.health_pay !== 'Yes',
          class: "",
        },
        {
          key: "account_management",
          img: "wallet@2x.png",
          text: "Account management",
          subText: "",
          show: this.benefits.account_management !== 'Yes',
          class: "",
        },
        {
          key: "virtual_card",
          img: "credit_facility@2x.png",
          text: "Virtual card",
          subText: "",
          show: this.benefits.virtual_card !== 'Yes',
          class: "",
        },
        {
          key: "instant_account_open",
          img: "discovery_phone@2x.png",
          text: "Instant account opening",
          subText: "",
          show: this.benefits.instant_account_open !== 'Yes',
          class: "",
        },
        {
          key: "upgrade",
          img: "timer@2x.png",
          text: "Upgrade in seconds",
          subText: "",
          show: this.benefits.upgrade !== 'Yes',

          class: "",
        },
        {
          key: "single_credit",
          img: "percentages@2x.png",
          text: "Single credit facility",
          subText: "",
          show: this.benefits.single_credit !== 'Yes',
          class: "single-credit",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.img-icon {
  height:2em;
}
.single-credit {
  height: 1.2em;

}
.center-features {
  position: absolute;
  top: 25%;
  //left: 50%;
  //transform: translateX(-50%) translateY(-50%);
  display: flex;
  align-items: center;
}
.card-item-a-b{
  height:9rem;
}
.subtext {
  font-size: 12px;
}

@media only screen and (min-width: 1200px ) {

  @media only screen and (max-width:1590px) {


    .single-credit{
      height: 0.7em !important;
    }
    .smallen-font {
      font-size: smaller !important;
    }
  }
  // .img-icon{
  //     height:2em;
  //   }

}

</style>
